module.exports = __webpack_public_path__ + "img/20190910162419981.44355e3f.jpg";